import React from 'react'
import './Rules.css'

export class Rules extends React.Component<{lang: string}, {}> {
    render(): JSX.Element {
        if (this.props.lang === 'ru') {
            return (
                <div className="Rules">
                    <h3>Карточная игра «Дурак» против программы «Балда»</h3>
                    <div>Несколько фактов о игре:</div>
                    <ul>
                        <li>
                            Балда держит свои <b>карты открытыми.</b> На то он и балда.
                        </li>
                        <li>
                            <b>Балда ничего не знает о ваших картах.</b> В алгоритм это не заложено. Правда.
                        </li>
                        <li>
                            Балда атакует, пока есть чем атаковать, и кроется, пока есть чем крыться. Но иногда может
                            пожадничать и не отдать козырь.
                        </li>
                    </ul>
                </div>
            )
        }
        return (
            <div className="Rules">
                <h3>Durak. It is a traditional Russian card game</h3>
                <p>
                    The deck is shuffled, and each player is dealt six cards. The bottom card of the stock is turned and
                    placed face up on the table, its suit determining the trump suit for the current deal. For example,
                    if it is the Seven of diamonds, then diamonds rank higher than all plain-suit cards. The rest of the
                    pack is then placed on half over the turnup and at right angles to it, so that it remains visible.
                    These cards form the prikup or talon. The turnup remains part of the talon and is drawn as the last
                    card. Cards discarded due to successful defences are placed in a discard pile next to the talon.
                </p>
                <p>The player with the lowest trump is the first attacker and leads to the first trick.</p>
                <p>
                    The Ace is the highest card of each suit and the Six is the lowest. A trump card of any rank beats
                    all cards in the other three suits. For example, a Six of trumps beats an Ace of any other suit.
                </p>
            </div>
        )
    }
}
